import types from "../types/type"

const toastData = ( _data) => {
    return { type: types.toast,  payload: _data};
}

export {toastData}